<template>
<div id="main">
    <div id="popup_wrap">
        <div class="popup-cont01">
            <div class="login_bg" v-bind:style="{backgroundImage: 'url(' + store_bg_image + ')', backgroundSize: '100%'} ">
                <div class="logo" v-bind:style="{width: logo_width_size+'px' , height: logo_height_size+'px'}"><img :src="store_main_image" /></div>
                <div class="main-content">
                    <div class="input-tag">
                    <form id="user_login" action="action/user_login.php" method="post">
                        <input type="text" class="input-touch" v-model="user_id" ref='user_id' v-on:focus='inputFocus("user_id")' autocomplete="off" full_length="13" name="user_hp" value="010" placeholder="휴대폰번호">
                        <input type="password" class="input-touch" full_length="4" name="user_password" v-model="user_password" ref='user_password' v-on:focus='inputFocus("user_password")' autocomplete="off" placeholder="비밀번호">
                    </form>
                    </div>
                    <div class="btn-tag">
                        <div class="sub-btn">
                            <span id="login" @click="move_page">로그인</span>
                            <span id="cancel2" @click="goToMain">취소</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <modals-container /> -->
</template>

<script>
const FOCUS_TYPE = {
    ID: {
        name: 'user_id',
        type: 'PHONE'
    },
    PASS: {
        name: 'user_password',
        type: 'PASSWORD'
    },
}

import numPad from '../components/num-pad';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';

import vue from 'vue';
vue.component('num-pad', numPad);
import * as appVue from '../../App.vue'

export default {
    name: 'Main',
    data() {
        return {
            flag: true,
            user_id: '',
            user_password: '',
            current_focus: FOCUS_TYPE.ID,
            parent_key_str: '',
            store_main_image : '',
            logo_width_size: 0,
            logo_height_size: 0,
            store_bg_image: ''
        }
    },
    methods: {
        inputFocus: function (type) {
            this.current_focus = type == FOCUS_TYPE.ID.name ? FOCUS_TYPE.ID : FOCUS_TYPE.PASS;
            if (this.current_focus === FOCUS_TYPE.ID) {
                this.parent_key_str = this.user_id;
            } else if (this.current_focus === FOCUS_TYPE.PASS) {
                this.parent_key_str = this.user_password;
            }
        },
        numPadInput: function (numberStr, overMaxLength) {

            // num-pad에 넘겨줄 값 변경.
            this.parent_key_str = numberStr;

            if (this.current_focus === FOCUS_TYPE.ID) {
                // hp
                this.user_id = numberStr;

                // set focus
                if (overMaxLength) {
                    this.$refs.user_password.focus();
                } else this.$refs.user_id.focus();
            } else if (this.current_focus === FOCUS_TYPE.PASS) {
                // password
                this.user_password = numberStr;

                // set focus
                if (!overMaxLength) this.$refs.user_password.focus();
                // else this.current_focus = null;
            }
        },
        move_page: function () {
            if (this.user_id != '' && this.user_password != '') {
                // 로그인하기
                const type = config.REQ_MEMBER_LOGIN;
                const data = {
                    data: {
                        'user_hp': this.user_id,
                        'password': this.user_password
                    }
                }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                    // }).then(function (response) { // => this.$store를 인식하지 못하는 문제로 아래 코드 사용.
                }).then((response) => {
                    // 이용제한 사용자 입니다. 관리자에게 문의하세요.

                    if (response.result && response.data.blacklist_yn != 1) {
                        this.$store.commit('set_user', {
                            user: response.data
                        });

                        //this.$store.state.login_chk = true;
                        this.$store.commit('change_login_chk', {
                            value: true
                        });
                        this.$store.commit('set_Item_register_info', {
                            id:'',
                            pass:'',
                            flag:false
                        });

                        const type = config.REQ_GET_BARCODE_INFO;
                        const data = {
                            'user_id' : this.$store.getters['getUser'].user_id
                        };
                        this.$store.dispatch(type.action_name, {
                            type: type,
                            data: data
                        }).then(response => {
                            if (response.result) {
                                if (response.data.length != 0) {
                                    for(let i=0;i<response.data.contents.length;i++){
                                        if(response.data.contents[i].barcode_type_code == "BARCODE_SEAT"){
                                            this.$store.commit('set_seat_barcode', response.data.contents[i].barcode_code );
                                        }
                                        if(response.data.contents[i].barcode_type_code == "BARCODE_GROOM"){
                                            this.$store.commit('set_groom_barcode', response.data.contents[i].barcode_code );
                                        }
                                    }
                                    
                                    
                                }
                            }
                        }).catch(function (error) {
                            console.log('error=============>', error);
                        });
                        var router = this.$router;
                        var last_url = this.$store.getters['get_last_url'];
                        if (last_url == undefined ||
                            last_url == null ||
                            last_url == '' ||
                            last_url == 'undefined' ||
                            last_url == 'null' ||
                            last_url.length == 0) {
                            router.push('/');
                        } else {
                            router.push(last_url); // 이동 위치를 입력
                        }
                    } else {
                        // 로그인 실패
                         this.$refs.user_password.focus();

                        let message = `휴대폰번호, 비밀번호가 일치하지 않습니다.</span><br /><br /><span>확인 후 재시도 바랍니다.`;
                        if (response.data.blacklist_yn == 1) message = `이용제한 사용자 입니다.</span><br /><br /><span>관리자에게 문의하세요.`;

                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: message,
                            router: '/login',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        return Promise.reject();
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            } else {
                // this.$store.state.login_chk = true;
                // this.$store.commit('change_login_chk', {
                //     value: true
                // });

                let message = `휴대폰번호 또는 비밀번호가 입력되지 않았습니다.</span><br /><br /><span>확인 후 재시도 바랍니다.`;

                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: message,
                    router: '/login',
                };
                this.$store.commit('set_popup_type', alert_param);

                // var router = this.$router;
                // router.push('/') // 이동 위치를 입력
            }

        },
        goToMain() {
            var router = this.$router;
            router.push('/'); // 이동 위치를 입력
        },
        register_modal_pop() {
            var router = this.$router;
            router.push('/register') // 이동 위치를 입력
        },
        change_pwd(){
            var router = this.$router;
            router.push('/password_edit') // 이동 위치를 입력
        },
        popup_message(message){
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: message,
                router: '/login',
            };
            this.$store.commit('set_popup_type', alert_param);
        }
    },
    mounted() {
        // let message = `비밀번호가 전화번호 뒤 4자리로<br> 변경되었습니다<br>
        //               변경된 비밀번호로 로그인 부탁합니다<br><br>
        //
        //               키오스크 좌석화면 상단의 마이페이지에서 수정이 가능합니다`;
        //
        // const alert_param = {
        //     code: this.$store.getters['get_popup_code'].POPUP_ALERT,
        //     message: message,
        // };
        // this.$store.commit('set_popup_type', alert_param);
        // store_logo_image
        var temp_store_main_image = this.$store.getters['getStoreInfo']['store_img'];
        if(typeof temp_store_main_image == 'undefined' || temp_store_main_image == ''){
            temp_store_main_image = config.SYS_HOST+'/images/kiosk/logo/logo.png';
        }else{
            temp_store_main_image = config.SYS_HOST+'/images/kiosk/logo/'+temp_store_main_image;
        }
        this.store_main_image = temp_store_main_image;
        this.logo_width_size = this.$store.getters['getStoreInfo']['logo_width_size'];
        this.logo_height_size = this.$store.getters['getStoreInfo']['logo_height_size'];

        // 로그인 초기값 설정.
        if( process.env.NODE_ENV == 'production' ){
            this.user_id = '010-';
            this.user_password = '';
        } else {
            this.user_id = '010-0000-0001';
            this.user_password = '0000';
        }

        this.$store.commit('change_login_chk', {
            value: false
        });
        this.$refs.user_id.focus();
        var register_info = this.$store.getters['getItem_register_info'];
        if(register_info.flag){
            this.user_id = register_info.id;
            this.user_password = register_info.pass;
            this.move_page();
        }

        this.store_bg_image = this.$store.getters['get_store_bg_img_url'];
    },

}
</script>



// WEBPACK FOOTER //
// src/components/page/login.vue